import './drag-drop-target.module.scss';
import React, { memo } from 'react';
import { Icon } from '~modules/ui/icon';
export const DragDropTarget = memo(() => {
    return (<div styleName="target">
      <Icon name="plus"/>
    </div>);
});
